import { render } from "./CreateOrder.vue?vue&type=template&id=2acbebe2&scoped=true"
import script from "./CreateOrder.vue?vue&type=script&lang=js"
export * from "./CreateOrder.vue?vue&type=script&lang=js"

import "./CreateOrder.vue?vue&type=style&index=0&id=2acbebe2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acbebe2"]])

export default __exports__